import { render } from "./NameSize.vue?vue&type=template&id=0f619354&scoped=true&ts=true"
import script from "./NameSize.vue?vue&type=script&lang=ts"
export * from "./NameSize.vue?vue&type=script&lang=ts"

import "./NameSize.vue?vue&type=style&index=0&id=0f619354&lang=scss&scoped=true"

import exportComponent from "/srv/users/dyo-frontend-staging/apps/dyo-frontend-staging/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f619354"]])

export default __exports__